export default __webpack_public_path__ + "static/media/videocall.2b64256a.png";